const getOrderServiceLookup = state => {
  return state.orderService;
};

export default {
  getOrderServiceLookup,
};
